export default __webpack_public_path__ + "static/media/sun.c2b57509.svg";